import React from 'react';
import Title from '../title/title.js';
import modules_4204a613 from './reading_since_and_count.module.scss.js';

const ReadingSinceAndCount = ({ type, readingData, loading }) => {
    const { readingsCount, yearJoined } = readingData;
    const getFontStyle = () => {
        if (type === "big")
            return "heading-h5";
        if (type === "medium")
            return "heading-h4";
        if (type === "default")
            return "content-default";
        if (type === "small")
            return "content-small";
        return "caption-1";
    };
    const renderReadingSinceAndCount = () => (React.createElement("div", { className: modules_4204a613["reading-since-and-count-container"] },
        React.createElement("div", { className: modules_4204a613["reading-since-and-count-readings-count-container"], "data-testid": "mbw-reading-since-and-count-readings-count-container" },
            React.createElement(Title, { fontStyle: getFontStyle(), bold: true, loading: loading }, readingsCount)),
        React.createElement("div", { className: modules_4204a613["reading-since-and-count-year-joined-container"], "data-testid": "mbw-reading-since-and-count-year-joined-container" },
            React.createElement(Title, { fontStyle: getFontStyle(), bold: true, loading: loading, ellipsis: true }, yearJoined))));
    return renderReadingSinceAndCount();
};

export { ReadingSinceAndCount as default };
//# sourceMappingURL=reading_since_and_count.js.map
